"use client";

import PropTypes from "prop-types";
import { Box, Typography, Grow } from "@mui/material";
import {
  HeroContentContainer,
  HeroContentTitle,
  HeroContentAboutContainer,
  HeroContentAboutImgWrapper,
  HeroContentAboutDesc,
  MobileDescription,
} from "./HeroContent.styles";
import Image from "next/image";

const HeroContent = ({ heroImage, inView }) => {
  const age = (() => {
    return Math.floor(
      (new Date() - new Date("1994-07-08").getTime()) / 3.15576e10
    );
  })();

  return (
    <HeroContentContainer>
      <Grow
        in={inView}
        {...(inView ? { timeout: 1000 } : {})}
        style={{ transformOrigin: "center center 0" }}
      >
        <HeroContentTitle variant={"h2"}>About Me</HeroContentTitle>
      </Grow>
      <Grow
        in={inView}
        {...(inView ? { timeout: 1500 } : {})}
        style={{ transformOrigin: "center center 0" }}
      >
        <Box>
          <HeroContentAboutContainer tabIndex={0}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HeroContentAboutImgWrapper>
                <Image
                  src={heroImage?.url}
                  alt={heroImage?.alt}
                  width={300}
                  height={300}
                  placeholder="blur"
                  blurDataURL={heroImage?.placeholder}
                  priority={true}
                />
              </HeroContentAboutImgWrapper>
              <MobileDescription>
                <Typography variant={"h3"}>
                  Hey there! I&apos;m Jace!
                </Typography>
                <Typography variantMapping={{ body1: "p" }}>
                  I&apos;m a {age} year old full stack developer based out of
                  Utah! I enjoy the outdoors, photography, 3d printing, and
                  coding!
                </Typography>
              </MobileDescription>
            </Box>
            <HeroContentAboutDesc>
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "column",
                }}
              >
                <Typography variant={"h3"}>
                  Hey there! I&apos;m Jace!
                </Typography>
                <Typography variantMapping={{ body1: "p" }}>
                  I&apos;m a {age} year old full stack developer based out of
                  Utah! I enjoy everything from the outdoors, photography, 3d
                  printing, and coding! (Of Course)
                </Typography>
              </Box>
              <Typography variantMapping={{ body1: "p" }}>
                I have held a variety of different jobs before deciding to
                pursue a coding career in 2021!
              </Typography>
              <Typography variantMapping={{ body1: "p" }}>
                I graduated from the University of Utah Full Stack Development
                bootcamp in 2023, and have been employed at Black Rifle Coffee
                Company as a Full Stack Developer for over a year now!
              </Typography>
            </HeroContentAboutDesc>
          </HeroContentAboutContainer>
        </Box>
      </Grow>
    </HeroContentContainer>
  );
};

HeroContent.propTypes = {
  heroImage: PropTypes.shape({
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    alt: PropTypes.string,
    placeholder: PropTypes.string,
  }),
  inView: PropTypes.bool,
};

export default HeroContent;
